import React from 'react';
import Form from 'react-bootstrap/Form'

function Priority(props) {

	var handlePriorityChange = function (range) {
		let priorityValue = getPriorityStringValue(range.target.value)
		props.onPriorityChange(priorityValue);
	}
	var getPriorityStringValue = function (priorityIntVal) {
		if (priorityIntVal === "3") return "HIGH";
		else if (priorityIntVal === "2") return "MEDIUM";
		else if (priorityIntVal === "1") return "LOW";
		else return "MEDIUM";
	}
	var getPriorityIntValue = function () {
		if (props.priority === 'HIGH') return 3;
		else if (props.priority === 'MEDIUM') return 2;
		else if (props.priority === 'LOW') return 1;
		else return 2;
	}

	const color = props.priority === 'HIGH' ? '#dc3545' : props.priority === 'LOW' ? '#198754' : '#ffc107';

	return (
		<div>
			<Form.Label><i className="bi bi-flag-fill me-1"></i>Priority: <span style={{ color }}>{props.priority}</span></Form.Label>
			<div style={{ height: '90px', display: 'flex', alignItems: 'center', paddingLeft: '8px' }}>
				<input
					type="range"
					min="1" max="3"
					value={getPriorityIntValue()}
					onChange={handlePriorityChange}
					style={{
						transform: 'rotate(270deg)',
						width: '80px',
						accentColor: color,
						cursor: 'pointer',
					}}
				/>
				<div className="d-flex flex-column justify-content-between ms-3" style={{ height: '80px', fontSize: '0.75rem', color: '#888' }}>
					<span>HIGH</span>
					<span>MED</span>
					<span>LOW</span>
				</div>
			</div>
		</div>
	);
}

export default Priority;
